export const DEFAULT_PRICING_DATA = {
  monthlyPrice: "4.99",
  yearlyPrice: "39.99",
  savings: "33%",
};
